import React, { useState }  from 'react';
import Button from '../../layout/forms/Button'
import apiObjectReports from '../../../api/objectReports';
import '../../../styles/home/report/GetReportButton.css'


const GetReportButton = ({ state, setData,ClearData }) => {

    const [loading, setLoading] = useState(false);
    const onClick = async () => {      
        setLoading(true);        
        ClearData();
        
        const data = await apiObjectReports.post({
            ...state,
            projects:state.projects.map(project => project.value),
            processAreas:state.processAreas.map(processArea => processArea.value),
            objectTypes: state.objectTypes.map(objectType => objectType.value),
            specifications: state.specifications.map(specification => specification.value),
            specificationDescs: state.specifications.map(specification => specification.label)
        });
        setData(data)
        setLoading(false);    
       
        
    }
    return (
        <>
            <Button className="get-report-button"
                onClick={onClick}>
                Search
            </Button>
            {loading ? <i className="fas fa-spinner get-report-spinner"></i>:null}
         </>
        )
}
export default GetReportButton
